import type dayjs from 'dayjs';

export enum UserStatus {
    DELETED = 0,
    ACTIVE = 1,
    NEW = 2,
    BLOCKED = 5,
}

export enum UserRole {
    ADMIN = 1,
    USER = 2,
    EDITOR = 3,
}

export interface User {
    id: number;
    role: UserRole;
    name: string;
    fullName: string;
    email: string;
    status: UserStatus;
    validDate: dayjs.Dayjs | null;
}

export interface ISuperAdminUser {
    id: number;
    name: string;
    email: string;
    parentId: number | null;
    type: number;
    status: number;
    timezone: string;
    directLoginLink: string;
}

export interface UsersState {
    users: Array<User>;
    usersByDate: Array<User>;
    isUsersLoaded: boolean;
    usersPermissions: Array<any>;
    fetch: boolean;
    superAdminUsers: Array<ISuperAdminUser>;
}

export const initialState: Readonly<UsersState> = {
    users: [],
    usersByDate: [],
    isUsersLoaded: false,
    usersPermissions: [],
    fetch: false,
    superAdminUsers: [],
};
